import React from "react";
import PropTypes from "prop-types";
import MaskedInput from 'react-text-mask'
import "./TextInput.css";

class CodeInput extends React.Component {
  //const { label } = props;
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: false
    };
  }
  onChangeHandler = e => {
    this.props.onChange(this.props.index);
  };

  onFocusHadler = e => {
    if(this.input && this.input.inputElement) {
      this.input.inputElement.select()
    }
  }
  
  value() {
      return this.input.inputElement.value;
  }
  render() {
    const {value} = this.props
    return (
        <MaskedInput
        ref={input => { this.input = input; }}
        mask={[/[0-9]/]}
        className="ha-tfc"
        guide={false}
        id="phoneInput"
        onFocus={this.onFocusHadler}
        onChange={this.onChangeHandler}
        autoFocus={this.props.autoFocus}
        value={value}
        type="tel"
        autoComplete="off"
/>
    );
  }
}
CodeInput.propTypes = {
  autoFocus: PropTypes.bool
};
CodeInput.defaultProps = {
  autoFocus: false
};
export default CodeInput;
